import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from './quote.actions';
import { Quote } from '@core/models/swagger';
import cloneDeep from 'clone-deep';
import { TAA } from '@core/models/swagger/bff';
import dayjs from 'dayjs';

export interface State {
  quote: Quote;
}

export const featureKey = 'flowDataQuote';

export const initialState: State = {
  quote: {}
};

export function quoteReducer(state: State | undefined, action: Action): State {
  return createReducer(
    initialState,
    on(Actions.ResetQuote, (state, {}) => ({
      ...state,
      quote: {}
    })),
    on(Actions.UpdateQuote, (state, { data }) => ({
      ...state,
      quote: cloneDeep(data),
    }))
  )(state, action);
}
